import Vue from "vue";
import VueI18n from 'vue-i18n'
import cn from "./language/cn"
import en from "./language/en"
import zh from "./language/zh"
import router from '../router'

Vue.use(VueI18n);   // 全局注册国际化包


const lang = window.location.search.includes('lang=zh') ? 'zh' : (window.location.search.includes('lang=en') ? 'en' : 'cn') ;
// this.$router.push({path: this.$route.path, query:{lang:lang} });
// console.log('ffffffffff', lang);
// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: lang,   // 初始化中文
  messages: {
    "cn":cn,
    "en":en,
    "zh":zh
  }
});

export default i18n



// WEBPACK FOOTER //
// ./src/local/index.js